import React, { ReactElement, ReactNode } from 'react';
import { Box, Theme, Typography } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  list: {
    margin: 0,
    padding: 0,
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    padding: spacing(1, 0),
  },
  property: {
    fontWeight: '600 !important',
    width: '40%',
  },
  value: {
    width: '60%',
  },
  picture: {
    height: 108,
    marginLeft: spacing(-3),
    width: 108,
  },
  emptyText: {
    color: colorPalette.grey.dark,
  },
}));

type Items = { left: string; right: ReactElement; key: string };

export function GridListDetails({
  items,
  messageNoItems,
}: {
  items: Items[];
  messageNoItems?: ReactNode;
}): React.ReactElement {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <ul className={classes.list}>
      {items.length === 0 ? (
        <span className={classes.emptyText}>{messageNoItems || t('generic.grid-list.empty')}</span>
      ) : (
        items.map(prop => (
          <Box key={prop.key} component="li" className={classes.listItem}>
            <Typography variant="body1" component="div" className={classes.property}>
              {prop.left}
            </Typography>
            <Typography variant="body1" component="div" className={classes.value}>
              <>{prop.right}</>
            </Typography>
          </Box>
        ))
      )}
    </ul>
  );
}
